import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=adc6838a&scoped=true&"
import script from "./tips.vue?vue&type=script&lang=js&"
export * from "./tips.vue?vue&type=script&lang=js&"
import style0 from "./tips.vue?vue&type=style&index=0&id=adc6838a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc6838a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adc6838a')) {
      api.createRecord('adc6838a', component.options)
    } else {
      api.reload('adc6838a', component.options)
    }
    module.hot.accept("./tips.vue?vue&type=template&id=adc6838a&scoped=true&", function () {
      api.rerender('adc6838a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/tips.vue"
export default component.exports